import { render } from "./ScrollTop.vue?vue&type=template&id=867744f8"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\이운혁\\Desktop\\util\\gitleb\\incheon\\incheon_tpps_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__